import { Dispatch } from 'react-redux';
import { removeAlertAction } from '../../app/actions/RemoveAlertAction';
import { updateAlertsAction } from '../../app/actions/UpdateAlertsAction';
import { updateAlertTotalAction } from '../../app/actions/UpdateAlertTotalAction';
import { ServiceLocator } from '../../app/ServiceLocator';
import { IAlertInfo, IAlertListInfo } from '../../ts/models/IAlertInfo';
import { Alerts } from '../../ts/resources/Alerts';
import { DataSources } from '../../ts/resources/Datasources';
import { ExtractTasks } from '../../ts/resources/ExtractTasks';
import { Workbooks } from '../../ts/resources/Workbooks';

export class AlertActions {

  private alerts: Alerts;
  private extractTasks: ExtractTasks;
  private datasources: DataSources;
  private workbooks: Workbooks;

  constructor(private dispatch: Dispatch<unknown>) {
    this.alerts = ServiceLocator.get<Alerts>('Alerts');
    this.extractTasks = ServiceLocator.get<ExtractTasks>('ExtractTasks');
    this.datasources = ServiceLocator.get<DataSources>('DataSources');
    this.workbooks = ServiceLocator.get<Workbooks>('Workbooks');
  }

  public getAlertCount() {
    this.alerts.getCount().then((count: number) => {
      this.dispatch(updateAlertTotalAction(count));
    });
  }

  public getAlerts() {
    this.alerts.getList().then((alertListInfo: IAlertListInfo) => {
      this.dispatch(updateAlertsAction(alertListInfo));
    });
  }

  public tryAgain(alert: IAlertInfo) {
    const taskId = alert.taskId;
    const extractType = alert.alertType; // either 'IncrementExtract' or 'RefreshExtract'.

    if(taskId) {
      // run extract task by ID
      this.extractTasks.run([taskId]).then(() => this.getAlerts());
    } else if (extractType) {
      // if we don't have a task ID,
      // we may need to run a datasource or workbook refresh by the item ID & refresh type.
      // if datasourceId is present, the alert item is a datasource.
      // if datasourceId is not present, the alert item is a workbook with ID affectedWorkbookIds[0].
      const datasourceId = alert.datasource && alert.datasource.id;
      const workbookId = alert.workbooks && alert.workbooks[0] && alert.workbooks[0].id;
      if (datasourceId) {
        // refresh datasource
        this.datasources.refreshExtracts([datasourceId], extractType).then(() => () => this.getAlerts());
      } else if (workbookId) {
        // refresh workbook
        this.workbooks.refreshExtracts([workbookId], extractType).then(() => () => this.getAlerts());
      }
    }

    this.dispatch(removeAlertAction(alert.id));
  }

}
